import { render, staticRenderFns } from "./BonusRecipeCarouselSectionModule.vue?vue&type=template&id=25887b88&"
import script from "./BonusRecipeCarouselSectionModule.vue?vue&type=script&lang=js&"
export * from "./BonusRecipeCarouselSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports